export default __webpack_public_path__ + "static/client_img3-e448d2951038711d26f4b48d80a8a30c.webp";